

import FetchApi from "./Components/FetchApi.js";
function App() {
  return (
    <div style={{backgroundColor:"#463E3F"}} className="App">
      
     <FetchApi/>
    </div>
  );
}

export default App;
